<script>
export default {
  name: "PropertyBuildingModal",
  data() {
    return {
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterLocation: "",
      sortDesc: false,
      fields: [
        {
          key: "buildingName",
          sortable: true,
        },
        {
          key: "buildingLocation",
          thStyle: { width: "200px" },
          sortable: true,
        },
        {
          key: "buildingDescription",
          thStyle: { width: "200px" },
          sortable: true,
        },
      ],
      campus: "",
      campusOptions: this.$store.state.decrypt.campusAccessList(),
      campusIdSelected: null,
      tableBusy: false,
    };
  },
  computed: {
    filtered() {
      let array = this.tableData;
      let keyword = this.filter;
      const regExp = new RegExp(keyword, "gi");
      const check = (obj) => {
        if (obj !== null && typeof obj === "object") {
          return Object.values(obj).some(check);
        }
        if (Array.isArray(obj)) {
          return obj.some(check);
        }
        return (
          (typeof obj === "string" || typeof obj === "number") &&
          regExp.test(obj)
        );
      };
      return array.filter(check);
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
  },
  methods: {
    getData() {
      this.campusIdSelected = this.$store.state.data.selectedCampus.id;
      this.tableBusy = true;
      this.$store
        .dispatch("propertylocation/GetBuilding", this.campusIdSelected)
        .then((res) => {
          this.tableBusy = false;
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            item.currentPage = 1;
            item.perPage = 10;
            item.tableBusy = false;
            item.locations = [];
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    dropData(data) {
      this.$emit("dropData", data[0]);
      this.$bvModal.hide("building-modal");
    },
  },
};
</script>

<template>
  <b-modal
    id="building-modal"
    title="Building List"
    size="xl"
    title-class="font-18"
    hide-footer
  >
    <div class="row mb-2">
      <div class="col-6"></div>
      <div class="col-6">
        <label class="d-flex align-items-center">
          <b-form-input
            autocomplete="off"
            v-model="filter"
            type="search"
            placeholder="Search building..."
            class="form-control mx-2 w-75"
          ></b-form-input>
          <b-form-select
            class="form-select w-25"
            v-model="perPage"
            :options="pageOptions"
          ></b-form-select>
        </label>
      </div>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="filtered"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        sort-by="id"
        :sort-desc.sync="sortDesc"
        :busy="tableBusy"
        bordered
        outlined
        striped
        show-empty
        select-mode="single"
        selectable
        @row-selected="dropData"
        selected-variant="success"
      >
        <template #empty>
          <div class="text-center">
            <div>
              <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
            </div>
          </div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(actions)="row">
          <div class="d-flex justify-content-between align-items-center">
            <div class="font-size-12 me-1" style="width: max-content">
              <a
                href="javascript: void(0);"
                class="text-info d-flex align-items-center"
                @click="viewLocations(row.item)"
              >
                View Locations
                <i class="bx bx-chevron-right rotate font-size-14"></i>
              </a>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>